import { v4 as uuidv4 } from 'uuid';
import { alertConstants } from '@constants/alert';

const initialState = {
    data: [],
};

function addAlert(state, action, type) {
    const id = action.id || uuidv4();
    const entry = {
        id,
        message: action.message,
        type,
        persistent: action.persistent || false,
        actionUrl: action.actionUrl || null,
        actionPath: action.actionPath || null,
        actionLabel: action.actionLabel || null,
        historyEntry: action.historyEntry,
    };
    return {
        ...state,
        data: [...state.data, entry],
    };
}

export function alert(state = initialState, action) {
    switch (action.type) {
        case alertConstants.SUCCESS:
            return addAlert(state, action, 'success');
        case alertConstants.ERROR:
            return addAlert(state, action, 'error');
        case alertConstants.CLEAR:
            return {
                ...state,
                data: state.data.filter(message => message.id !== action.id),
            };
        case alertConstants.CLEAR_ALL:
            return initialState;
        case alertConstants.CLEAR_OTHER_PAGES: {
            const data = state.data.filter(message => message.historyEntry === action.historyEntry);
            return data.length === state.data.length ? state : { ...state, data };
        }
        default:
            return state;
    }
}
